import { bool, func, oneOf, string } from 'prop-types'
import { memo } from 'react'
import { IMaskInput } from 'react-imask'
import styled from 'styled-components'
const StyledInput = styled(IMaskInput)`
	background-color: #ffffff;
	border-color: #e1e1e1;
	border-radius: 10px;
	border-style: solid;
	border-width: 1.5px;
	color: #292b32;
	font-weight: 500;
	outline: none;
	width: 100%;
	/* 52, 44, 36 */
	font-size: 16px;
	height: 44px;
	padding-left: 15px;
	padding-right: 15px;
	&[data-size='large'] {
		font-size: 18px;
		height: 52px;
		padding-left: 18px;
		padding-right: 18px;
	}
	&[data-size='small'] {
		font-size: 14px;
		height: 36px;
		padding-left: 12px;
		padding-right: 12px;
	}
	&[data-hide-border='true'] {
		border-width: 0;
	}
	&::placeholder {
		color: #717171;
	}
	&[data-error='true']:not(:disabled) {
		border-color: #e41d32;
	}
	&:hover:not(:disabled) {
		border-color: #018ecc;
	}
	&:focus {
		border-color: #018ecc;
	}
	&:disabled {
		background-color: #f4f4f4;
		color: #717171;
		cursor: default;
	}
	.dark & {
		background-color: #2e2d2d;
		border-color: #555555;
		color: #e1e1e1;
		&[data-error='true']:not(:disabled) {
			border-color: #e41d32;
		}
		&:hover:not(:disabled) {
			border-color: #018ecc;
		}
		&:focus {
			border-color: #018ecc;
		}
		&:disabled {
			color: #717171;
		}
	}
`
const InnInput = memo(
	({
		'data-cy': dataCY,
		hideBorder = false,
		isDisabled = false,
		isError = false,
		onChange,
		onFocus,
		placeholder = '',
		size = 'medium',
		value = '',
	}) => (
		<StyledInput
			className='inn-input'
			data-cy={dataCY}
			data-error={isError}
			data-hide-border={hideBorder}
			data-size={size}
			disabled={isDisabled}
			inputMode='numeric'
			mask='000000000'
			onAccept={onChange}
			onFocus={onFocus}
			placeholder={placeholder}
			type='text'
			value={value}
		/>
	)
)
InnInput.propTypes = {
	'data-cy': string,
	hideBorder: bool,
	isDisabled: bool,
	isError: bool,
	onChange: func,
	onFocus: func,
	placeholder: string,
	size: oneOf(['large', 'medium', 'small']),
	value: string,
}
export default InnInput
